import React from 'react'
import { moduleContext } from 'react-contextual'
import { useDispatch, useStore, useSelector } from 'react-redux'
import { agencyApiSelectors } from '../../modules/api/agency'
import { userApiSelectors, userApiEvents } from '../../modules/api/user'
import { uiEvents } from '../../modules/ui'
import { ROUTES } from 'constants/routes'
import { reportingApiEvents, reportingApiSelectors } from '../api/reporting'

const DashboardProvider = moduleContext()(({ context, children, ...props }: any) => {
  const store = useStore()
  const dispatch = useDispatch()
  const state = store.getState()

  useSelector(agencyApiSelectors.agency)

  const currentAgencyId = userApiSelectors.getCurrentAgencyId(state)

  const dashboardStore = {
    currentAgencyId,
    logoUrl: agencyApiSelectors.getAgencyLogo(state)(currentAgencyId),
    agencyName: agencyApiSelectors.getAgencyName(state)(currentAgencyId),
    agencyTrading: agencyApiSelectors.getAgencyTradingName(state)(currentAgencyId),
    agencyTheme: agencyApiSelectors.getAgencyTheme(state)(currentAgencyId),
    userName: userApiSelectors.getUserFirstName(state),
    userEmail: userApiSelectors.getUserEmail(state),
    fetchAgencyPerformanceSummaryChart: () =>
      dispatch(reportingApiEvents.agencyPerformanceSummaryChart_request({ granularity: 'monthly' })),
    monthlyAgencyPerformanceSummaryChart: useSelector(reportingApiSelectors.getMonthlyPerformanceSummary),
    // The dashboard makes a single consolidated data call:
    // /reports/dashboard-summary-stats serves every tile (deposit/transactional/
    // commission balances, the commission & funds-collected 30-day flows, the
    // recon settled%/funds, and the portfolio counts). The transactional and
    // deposit bank statements are no longer prefetched on load — they're fetched
    // only when the user opens a statement (openBankStatement / openDepositBankStatement).
    fetchDepositSummaryStats: () => dispatch(reportingApiEvents.depositSummaryStats_request()),
    redirect: (path: any) => dispatch(uiEvents.redirect(path)),
    openBankStatement: () => dispatch(uiEvents.redirect(ROUTES.bankStatement)),
    openDepositBankStatement: () => dispatch(uiEvents.redirect(ROUTES.depositBankStatement)),
    logout: () => dispatch(userApiEvents.logout_request()),
    ...props,
  }
  return <context.Provider value={dashboardStore}>{children}</context.Provider>
})

export default DashboardProvider
